import { render } from "./PublicationProFeature.vue.js?vue&type=template&id=2ecd37dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProFeature.vue?vue&type=template&id=2ecd37dc"
import script from "./PublicationProFeature.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProFeature.vue?vue&type=script&lang=js"
export * from "./PublicationProFeature.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationProFeature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ecd37dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ecd37dc', __exports__)) {
    api.reload('2ecd37dc', __exports__)
  }
  
  module.hot.accept("./PublicationProFeature.vue.js?vue&type=template&id=2ecd37dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProFeature.vue?vue&type=template&id=2ecd37dc", () => {
    api.rerender('2ecd37dc', render)
  })

}


export default __exports__